var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    transform: "translate(13 13)",
    d: "M13.5 1.5L6.5 1.5C5.9468751 1.5 5.5 1.947813 5.5 2.5L5.5 3L4 3L4 2.5C4 1.1193752 5.1187501 0 6.5 0L13.5 0C14.88125 0 16 1.1193752 16 2.5L16 9.5C16 10.88125 14.88125 12 13.5 12L13 12L13 10.5L13.5 10.5C14.053125 10.5 14.5 10.053125 14.5 9.5L14.5 2.5C14.5 1.947813 14.053125 1.5 13.5 1.5ZM10 4C11.103125 4 12 4.8968754 12 6L12 14C12 15.103125 11.103125 16 10 16L2 16C0.89531231 16 0 15.103125 0 14L0 6C0 4.8968754 0.89531231 4 2 4L10 4ZM2 14.5L10 14.5C10.275 14.5 10.5 14.275 10.5 14L10.5 8L1.5 8L1.5 14C1.5 14.275 1.7237501 14.5 2 14.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.84635f602c28af1b626675353f31fe08.svg";
export { ForwardRef as ReactComponent };